<template>
  <section class="vbox">
    <section class="scrollable padder">
      <section class="row m-b-md brud-theme">
        <div class="col-sm-6 text-black">
          <ol class="breadcrumb text-left">
            <li>
              <a href="#"><i class="fa fa-dashboard"></i> Home</a>
            </li>
            <li class="active">List of Brands</li>
          </ol>
        </div>
        <div class="col-sm-6 text-right text-left m-t-sm">
          <small> </small>
        </div>
      </section>

      <section class="panel panel-default">
        <header class="panel-heading">
          <div class="row">
            <div class="col-sm-12">
              <a
                v-on:click="showBrandForm()"
                class="btn btn-success pull-right"
              >
                <i class="fa fa-plus"> </i> New Brand
              </a>
              <h4>
                <i class="fa fa-list-ul"></i>
                Search Brand
              </h4>
            </div>
          </div>
        </header>
        <!-- <div class="modal-body">
          <form @submit.prevent="getBrands()" method="post">
            <div class="row">
              <div class="col-sm-4">
                <div class="form-group">
                  <label> Category</label>
                  <select
                    class="form-control "
                    v-model="type_job"
                    id="type_job"
                    name="type_job"
                    style="width: 100%;"
                  >
                    <option value="0">Choose Job Type </option>
                    <option
                      v-for="(type, index) in jobTypes"
                      :key="index"
                      v-bind:value="index"
                      >{{ type }}</option
                    >
                  </select>
                </div>
              </div>
              <div class="col-lg-4">
                <div class="form-group" style="padding-top: 25px;">
                  <button type="submit" class="btn btn-success">
                    &nbsp;&nbsp;&nbsp; Search &nbsp;&nbsp;&nbsp;
                  </button>
                  <a href="" class="btn btn-danger"
                    >&nbsp;&nbsp;&nbsp;&nbsp; Reset &nbsp;&nbsp;&nbsp;&nbsp;</a
                  >
                </div>
              </div>
            </div>
          </form>
        </div> -->
      </section>
      <panel-modal
        v-if="showFormModal"
        class-list="col-md-6"
        @close="showFormModal = false"
      >
        <template #header>
          <h4>
            <i class="fa fa-list-ul"></i>
            Add / Edit Brand
          </h4>
        </template>
        <template #body>
          <AddBrand
            :brandId="brandId"
            v-on:list-brands="getBrands()"
            v-on:hide-brand="showFormModal = false"
          />
        </template>
      </panel-modal>
      <section class="content">
        <div class="row">
          <div class="col-md-12">
            <div class="box">
              <div class="panel panel-default">
                <div class="panel-heading">
                  <i class="fa fa-list-ul"></i>
                  BRANDS LIST
                </div>
                <div style="overflow-x:auto;" class="panel-body">
                  <table
                    width=""
                    class="table table-striped table-bordered table-hover"
                  >
                    <thead>
                      <tr>
                        <th width="5%">#</th>
                        <th width="10%">Brand</th><!--
                        <th width="10%">Color Code</th>
                        <th width="10%">Sort Order</th>
                        <th width="10%">Status</th>-->
                        <th width="10%">Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="brand in brandList"
                        :key="brand.brand_id"
                      >
                        <td id="sino"></td>
                        <td>
                          {{ brand.brand_name }}</td>
                          <!--<br />
                          <img
                            :src="baseUrl + category.category_image"
                            width="50"
                            height="50"
                          />
                        </td>
                        <td>{{ category.color_code }}</td>
                        <td>{{ category.sort_order }}</td>
                        <td>
                          <div class="switch">
                            <label>
                              <input type="checkbox" checked />
                              <span class="lever"></span>
                              <label
                                v-if="StatusActive == true"
                                class="label bg-green"
                              >
                                Active</label
                              >
                              <label v-else class="label bg-red">Block</label>
                            </label>
                          </div>
                        </td>
                        -->
                        <td>
                          <a
                            v-on:click="showBrandForm(brand.brand_id)"
                            class="btn label-warning btn-xs"
                            style="float: left;display: block; width: 100%;"
                            ><i class="fa fa-edit"></i> Edit</a
                          >
                        </td>
                      </tr>
                    </tbody>
                  </table>

                  <!-- Show pagination links -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </section>
  </section>
</template>

<script>
//import $ from 'jquery'
//import axios from 'axios'

import api from "../api";
import AddBrand from "../components/AddBrand.vue";
import PanelModal from "../components/PanelModal.vue";

export default {
  name: "Brand",

  components: {
    AddBrand,
    PanelModal,
  },
  data() {
    return {
      showFormModal: false,
      baseUrl: this.$store.state.baseURL,
      brandList: {},
      brandId: "",
      StatusActive: true,
    };
  },
  methods: {
    getBrands: function() {
      const brandlist = {
        filter: {
        },
      };
      api
        .request("post", "GeneralApis/get_brands", brandlist)
        .then((response) => {
          var data = response.data;
          console.log(data);
          if (data.errorcode) {
            if (data.errorcode === 25000) {
              this.$router.push('/login')
            }
            this.brandList = response.data.values;
          } else {
            this.brandList = data.brandList;
          }
        });
    },
    showBrandForm: function(brandid) {
      this.brandId = brandid;
      this.showFormModal = true;
    },
  },
  mounted(){
    this.getBrands()
  }
};
</script>
